import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Alonehere from "./../src/assets/icons/alonehere.svg";
import logo from "./images/TestAssessify.png";
import LanguageSwitcher from './components/LanguageSwitcher';

function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="relative h-screen bg-white">
      <div className="w-full flex justify-between pb-4 h-26 bg-inherit sticky top-0 cursor-pointer">
        <div className="h-full">
          <img
            src={logo}
            alt="Test Assessify"
            className="w-56 h-full object-contain"
          />
        </div>
        <LanguageSwitcher 
          className='border border-slate-300 mr-5 py-3 px-3 rounded-xl focus:border-slate-300 focus:outline-none' 
          containerClassName='flex items-center justify-center' 
        />
      </div>
      <div className="grid place-content-center h-full">
        <div className="relative z-10 flex flex-col items-center w-full font-mono">
          <p className="font-extrabold text-primary text-8xl animate-bounce italic">
            {t('oops')}
          </p>
          <h1 className="mt-4 text-5xl font-bold leading-tight text-center text-primary mb-10">
            {t('page-not-found')}
          </h1>
          <Link to="/" className="text-darkBlue text-xl border rounded-lg border-primary p-4">
            {t('go-back-home')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
